import { DropdownButton, Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import {
  Conversation,
  ConversationSummaryLabel,
} from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';
import * as React from 'react';

import {
  ConversationDetails,
  ConversationDetailsLayout,
} from 'components/conversation/conversationDetails';
import { metaConversation } from 'components/conversation/utils/conversationObjectConverters';
import { clickWithFocus } from 'components/shared/util/clickWithFocus';

import styles from './subConversationList.module.scss';

export type SubConversationListItem = {
  info: Conversation;
  requester?: User;
  labels: ConversationSummaryLabel;
};

type PropsT = {
  /** Extra classnames */
  className?: string;
  /** Conversations */
  conversations: SubConversationListItem[];
  /** Callback when a conversation is clicked */
  onConversationClick: (csid: number | string) => void;
};

export class SubConversationList extends React.PureComponent<PropsT> {
  getDropdownContent(
    linkedConversations: SubConversationListItem[],
  ): React.ReactNode {
    const { onConversationClick } = this.props;

    return (
      <div className={styles.dropdownContent}>
        {linkedConversations.map((linkedConversation, index) => (
          <div
            key={`${linkedConversation.info.id}-${index}`}
            {...clickWithFocus(() => {
              if (linkedConversation.info.id) {
                onConversationClick(linkedConversation.info.id);
              }
            })}
          >
            <ConversationDetails
              className={styles.dropdownItem}
              conversationName={linkedConversation.labels.title ?? null}
              layout={ConversationDetailsLayout.SideConversation}
              metaConversation={metaConversation.from.conversation(
                linkedConversation.info,
                linkedConversation.requester,
              )}
            />
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { className, conversations, onConversationClick, ...otherProps } =
      this.props;

    const rootClass = classnames(
      {
        [styles.root]: true,
      },
      className,
    );

    let visibleConversations = conversations;
    let extraConversations: PropsT['conversations'] | null = null;
    if (conversations.length > 3) {
      visibleConversations = conversations.slice(0, 3);
      extraConversations = conversations.slice(3);
    }

    return (
      <div {...otherProps} className={rootClass}>
        {visibleConversations.length > 0 && (
          <Icon name="link" size={16} className={styles.linkIcon} />
        )}
        {visibleConversations.map((linkedConversation, index) => (
          <div
            key={`${linkedConversation.info.id}-${index}`}
            className={styles.item}
          >
            <div
              className={styles.itemInner}
              {...clickWithFocus(() => {
                if (linkedConversation.info.id) {
                  onConversationClick(linkedConversation.info.id);
                }
              })}
            >
              <ConversationDetails
                conversationName={linkedConversation.labels.title ?? null}
                layout={ConversationDetailsLayout.SideConversation}
                metaConversation={metaConversation.from.conversation(
                  linkedConversation.info,
                  linkedConversation.requester,
                )}
              />
            </div>
          </div>
        ))}

        {!!extraConversations && (
          <DropdownButton
            buttonProps={{ className: styles.dropdownButton }}
            noArrow
            dropdown={this.getDropdownContent(extraConversations)}
          >
            {`+${extraConversations.length}`}
          </DropdownButton>
        )}
      </div>
    );
  }
}
